import React from "react";
import { Badge } from "flowbite-react";
import { HiX } from "react-icons/hi";
import { WorkspaceTagType } from "../../pages/workspace/Api";

interface WorkspaceTagProps {
  tag: WorkspaceTagType;
  onDelete?: () => void;
  showDelete?: boolean;
}

export function WorkspaceTag({
  tag,
  onDelete,
  showDelete = false,
}: WorkspaceTagProps) {
  const color = tag.color || "gray";

  return (
    <Badge
      color={color}
      className={`bg-${color}-100 text-${color}-800`}
      size="xs"
    >
      <div className="flex flex-row items-center gap-1">
        <span>{tag.name}</span>
        {showDelete && onDelete && (
          <HiX
            className="w-3 h-3 cursor-pointer hover:opacity-70"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          />
        )}
      </div>
    </Badge>
  );
}
